// /**
//  * 基础配置
//  *
//  **/
// export default {
//   debug: true, // 是否开启调试输出
//   isTest: true, // 是否开启测试, 将调用测试数据[弃用]
//   version: '2022.5.16', // 版本号, 需要清理缓存时, 修改; 同时在线用户会退出
//   url: {
//     isCross: true, // 是否开启跨域请求, 本机开启, 上环境请设置为false
//     api: '' // 开发环境
//   }
// };

export const  JSON_URL='./static/json/';



// WEBPACK FOOTER //
// ./src/configs/base.js